// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"61384339","879":"a9711643"}[chunkId] + ".chunk.js";
};